export const habaCheckout = {
  habaOrderSummary: {
    subTotal: 'Warenwert',
    shipping: 'Versandkosten',
    shippingSPED: 'Versandkosten inkl. Speditionskosten',
    totalDiscounts: 'Rabatte',
    promotionSavings: 'Ersparnis aus Aktionen',
    promotionCoupons: 'Aktionsvorteil',
    totalSavings: 'Gesamtersparnis:',
    giftCard: 'Gutschein',
    giftCards: 'Gutscheine',
    giftCardsResidualValue: 'Restwert Gutschein',
    total: 'Gesamtsumme',
    safeSSL: 'Alle Angaben in {{currency}} inkl. MwSt. zzgl. Versand- und Servicekosten.',
    help: 'Benötigen Sie Hilfe?',
    subHelp1: 'Kontaktieren Sie',
    subHelp2: 'hier unseren Kundenservice',
    btn: {
      label_0: 'Weiter zur Zahlungsart',
      label_1: 'Weiter zur Übersicht',
      label_2: 'Weiter zur Übersicht',
    },
    portoFlatrate: {
      title: 'Porto-Flatrate:',
      text: 'einmalig <strong>{{price}}</strong> danach {{days}} Tage portofrei in ganz {{country}}.',
      moreInfo: 'Erfahren Sie',
      more: 'mehr',
      expirationInfo: 'Porto-Flatrate gültig bis {{expirationDate}}',
      cancel: 'Entfernen',
    },
    promotionsGiftcardInfo:
      'Vorteilscodes und Gutscheine können im letzten Schritt eingelöst werden.',
    promotionsInfo: 'Vorteilscodes können im letzten Schritt eingelöst werden.',
    promotionsInfoTemporary:
      'Momentan kannst du leider keine Vorteilscodes einlösen – wir arbeiten aber mit Hochdruck daran, dass das bald wieder möglich ist.',
    minAmountForFreeDelivery: 'Ab {{amount}} Warenwert ist deine Bestellung versandkostenfrei',
    backToShopping: 'Weiter einkaufen',
    untilFreeCost: 'bis zum kostenlosen Versand!',
    priceSimulateFailed:
      'Aktuell können keine Promotions angewendet werden. Beende die Bestellung ohne Aktionen und Vorteilsnummern oder versuche es später noch einmal',
    priceUpdateModal: {
      headline: 'Produktaktualisierungen',
      copy: 'Oh! Es sieht so aus, als ob bei einigen Produkten, die du in den Warenkorb gelegt hast, eine Preisaktualisierung stattgefunden hat. Bitte wirf einen Blick darauf und entscheide, ob du diese Produkte weiterhin in der Bestellliste behalten willst oder sie hier per Klick entfernen möchtest. Bitte beachte dieser Preis-Check berücksichtigt keine Preisreduzierungen aus aktuellen Aktionen.',
      subHeadline: 'Überprüfen Sie Ihre aktualisierten Produkte',
      oldPrice: 'Alter Preis',
      newPrice: 'Neuer Preis',
      removeButton: 'Entfernen',
      stayButton: 'Behalten',
      stayAllButton: 'Alle im Warenkorb behalten',
    },
    helperTitle: 'Vorteilscode und Gutscheine können im letzten Schritt eingelöst werden.',
  },
  habaConfirmation: {
    thankYouHeading: 'Vielen Dank für deine Bestellung!',
    thankYouText:
      'Die Bestätigung deiner Bestellung und weitere Informationen zum Widerrufsrecht und Rückgabe erhältst du per E-Mail an folgende Adresse',
    total: 'Gesamtbetrag',
    haveOneSecond: 'Noch ein paar Sekunden Zeit?',
  },
  habaPayment: {
    paymentMethod: 'Zahlungsart',
    paymentMethodNotSelected: 'Bitte wähle eine Zahlungsmethode.',
    paymentMethodNotActive: {
      title: 'Bitte versuche es mit einer anderen Zahlungsart.',
      message:
        '<b>Zahlung auf Rechnung ist leider nicht möglich,</b> weil deine Rechnungsadresse ist außerhalb von Deutschland, Österreich und der Schweiz.',
    },
    birthdateModal: {
      title: 'Bitte weise Deine Identität nach',
      paragraph:
        'Für diese Zahlungsmethode benötigen wir zusätzliche Daten zum Nachweis Deiner Identität. Danach kannst Du deinen Einkauf abschließen.',
      dataProtection: 'Datenschutzerklärung',
      inputPlaceholder: 'Geburtstag (TT.MM.JJJJ)',
      submitButton: 'Bestätigen',
      dataProtectionLink: 'Datenschutzerklärung',
      dataProtectionText: 'Es gilt unsere',
    },
    birthdateError: {
      title: 'Zahlungsart leider nicht zugelassen.',
      paragraph:
        'Du wurdest für die Verwendung dieser Zahlungsart leider nicht zugelassen Bitte versuche es mit einer anderen Zahlungsart.',
    },
    disabledPaymentMethods: {
      and: 'oder',
      isDisabledForGiftCards:
        '{{restrictedPaymentMethods}} kann nicht mit <b>Gutscheinen</b> verwendet werden.',
      isDisabledForPortoFlatrate:
        '{{restrictedPaymentMethods}} kann nicht verwendet werden, während <b>Porto-Flatrate</b> erworben wird.',
      advancePayment:
        'Bitte beachten Sie, dass die Zahlungsart Vorkasse nicht zusammen mit einem Gutscheinen verwendet werden kann.',
    },
    submitButton: 'Schließen',
    termsAndConditions: 'Ja, ich stimme den AGB zu. Unsere Datenschutzerklärungen finden sie hier',
    standardPaymentInfoTip:
      'Unser Standardversand wird von etablierten Versanddienstleistern wie <b>UPS oder DHL</b> durchgeführt. Je nachdem welcher Zusteller in ihrer Region die beste Leistung bietet, wählen wir den passenden Partner aus. Für Lieferungen nach Österreich erfolgt die Zustellung durch die österreichische Post.',
    paymentModes: {
      ct_paypal: 'PayPal',
      ct_creditcard_hop: 'Kreditkarte',
      advancePayment: 'Vorkasse',
      invoice: 'Rechnung',
    },
    paymentModesDescription: {
      ct_paypal:
        'Mit PayPal bezahlen ist einfach, schnell und sicher! Hinweis: Die Abfrage deiner Daten erfolgt nach dem Absenden der Bestellung. Du musst deine PayPal-Daten bei jedem Einkauf neu eingeben. Beim Bezahlen per PayPal wird auf die Website von PayPal weitergeleitet. Hierfür gelten die AGB von PayPal.',
      ct_creditcard_hop:
        'Du wirst nach dem Absenden der Bestellung zur Kreditkartenzahlung (HOP hosted order page) weitergeleitet.',
      advancePayment: 'Die Zahlung kann im Voraus erfolgen',
      invoice:
        'Zahlung nach Erhalt der Ware. Du zahlst den Rechnungsbetrag ganz bequem per Überweisung innerhalb von 14 Tagen. Wir senden dir die Rechnung vorzugsweise per E-Mail zu (PDF-Anhang).',
    },
    giftcardRedemptionDisabledTitle:
      'Gutscheine können mit der Zahlungsart Vorkasse nicht eingelöst werden',
    giftcardRedemptionDisabledDescription:
      'Bitte wählen Sie eine andere Zahlungsart, wenn Sie einen Gutschein einlösen möchten.',
    giftcardRedemptionDisabledButton: 'Ohne Gutschein fortfahren',
    giftcardRedemptionDisabledButtonSubmit: 'Zahlungsart ändern',
  },
  habaPlaceOrder: {
    agb: 'Ja, ich stimme den <a href="{{agbUrl}}" target="_blank" rel="noopener noreferrer">AGB</a> zu.',
    dataProtection:
      'Unsere Datenschutzerklärungen finden Sie <a href="{{privacyUrl}}" target="_blank" rel="noopener noreferrer">hier</a>.',
    placeOrder: 'Jetzt Zahlungspflichtig bestellen',
    placeOrderShort: 'Jetzt bestellen',
    agbError:
      'Bitte bestätige, dass du unsere AGBs und Datenschutzerklärung gelesen und akzeptiert hast.',
    phoneModal: {
      title: 'Telefonnummer bearbeiten',
      text: 'Deine Telefonnummer wird benötigt, damit der Spediteur dich kontaktieren kann',
      inputPlaceholder: 'Telefonnummer',
      submitButton: 'Speichern und weiter',
    },
    phoneErrorMessage:
      'Deine Telefonnummer <b>wird benötigt</b>, damit der <b>Spediteur dich kontaktieren</b> kann.',
    phoneSuccessMessage:
      'Das Telefonnummernformat scheint korrekt zu sein. Bitte speichern Sie zuerst Ihre Updates und dann <b>Jetzt Zahlungspflichtig bestellen</b>.',
    negativeTotalError:
      'Ein Fehler ist aufgetreten. Gutschein-Einlösung und Aktionsrabatt führen zu einem Negativbetrag. Entferne den Gutschein oder den Aktionsrabatt, um die Bestellung beenden zu können.',
  },
  habaGuestLogin: {
    heading: 'Als Gast bestellen',
    emailAddress: {
      label: 'E-Mail Adresse',
      error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    emailConfirmationAddress: {
      label: 'E-Mail Adresse bestätigen',
      error: 'Die E-Mail Adresse und die E-Mail-Wiederholung stimmen nicht überein.',
    },
    button: 'Zur Gastbestellung',
  },
  habaCheckoutProgress: {
    login: 'Anmelden',
    methodOfPayment: 'Zahlart',
    shippingAddress: 'Adresse',
    deliveryMode: 'Lieferung',
    paymentDetails: 'Zahlung',
    reviewOrder: 'Bestätigen',
  },
  habaCheckoutInforbarText: {
    freeReturn: '14 Tage kostenlose Rückgabe',
    noMinimumOrderValue: 'Kein Mindestbestellwert',
    carefullyTestedProducts: 'Sorgfältig getestete Ware',
    sparePartService: 'Ersatzteilservice',
  },
  habaCheckoutReview: {
    review: 'Deine Übersicht',
    cardTitle: {
      shippingAddress: 'Lieferadresse',
      billingAddress: 'Rechnungsadresse',
      paymentMethod: 'Zahlungsart',
      deliveryMethod: 'Versandart',
      email: 'E-Mail Adresse',
      telephone: 'Telefonnummer',
    },
    errors: {
      syncAtpCheckProductNotAvailable:
        'Bestand nicht mehr verfügbar. Ein oder mehrere Produkte wurden aus Ihrem Einkaufswagen entfernt.',
      syncAtpCheckProductQuantityChanged:
        'Bestand nicht mehr verfügbar. Bei einem oder mehreren Produkten wurden die Mengen verringert.',
      generic:
        'Bestellung kann nicht abgeschlossen werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unser Support-Team',
      syncAtpCheckProductNotAvailableQuantityChanged:
        'Bestand nicht mehr verfügbar. Ein oder mehrere Produkte wurden aus Ihrem Einkaufswagen entfernt & bei einm oder mehreren Produkte wurden die Mengen verringert.',
      cartItemsPriceChanged:
        'Produktpreise wurden aktualisiert. Bitte prüfen sie erneut Ihre Bestellung',
      cartChanged: 'Ihr Warenkorb wurde aktualisiert.',
      giftCardsRemoved:
        'Eine oder mehrere Geschenkkarten wurden entfernt. Bitte fügen Sie diese erneut hinzu.',
      invalidPaymentDetails: 'Bitte aktualisieren Sie Ihre Zahlungsmethode',
      companyAddressesChanged:
        'Ihre Firmendaten haben sich geändert. Bitte wählen Sie Ihre Adressen erneut aus.',
      genericpayment:
        'Während der Kontaktaufnahme zum Zahlungsanbieter ist ein Problem aufgetreten. Warte einige Minuten und versuche es erneut oder wähle eine andere Zahlungsmethode. Wenn das Problem weiterhin auftritt, wende dich an unser Kundenservicecenter.',
      paymentcanceled:
        'Der Bezahlvorgang wurde abgebrochen. Bitte wählen Sie eine Zahlungsmethode, um fortzufahren.',
      orderFromCartAlreadyExists:
        'Für Ihren Warenkorb ist bereits eine Bestellung eingegangen. Bitte prüfen Sie Ihre E-Mails oder kontaktieren unseren Kundenservice.',
      purchaseGiftcardsAndRedemption:
        'Die Gutscheineinlösung wurde entfernt. Beim Kauf von Wertgutscheinen kann kein Gutschein als Zahlungsmittel verwendet werden',
    },
  },
  habaDeliveryModes: {
    title: 'Versand',
    'standardversand-haba-de': 'Standardversand',
  },
  habaCheckoutFooter: {
    customerService: {
      title: 'Kundenservice',
      description: 'Montag bis Freitag von 8 bis 16 Uhr im Kunden-Service-Center in Bad Rodach!',
    },
    paymentMethods: {
      title: 'Zahlungsarten & sicheres Einkaufen',
      note: 'Preisangaben in Euro inkl. gesetzl. MwSt. und zuzüglich Service- und Versandkosten',
    },
  },
};
